import React, { Component } from 'react';
import swal from 'sweetalert';
import { Table } from 'react-bootstrap';
import Modal from '../../../components/Modal';

class SelectFormatPrint extends Component{
    constructor(props){
        super(props);

        this.openModal = this.openModal.bind(this);
        this.clear = this.clear.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.onPrint = this.onPrint.bind(this);

        this.state = {
            sections:[],
            serology:false,
            select_section:false
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    componentWillUnmount(){
        this.props.onRef(null);
    }

    openModal(){
        var lab_sections = JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"));
		var section_lab = this.props.sections;
		var sections = [];
		
		lab_sections.forEach((s)=>{
            var index = section_lab.findIndex(obj => obj.ID === s.lab_sections_id);

            if(index !== -1){
                sections.push({
                    check:false,
                    lab_section_name:section_lab[index].Name,
                    lab_section_id:section_lab[index].ID
                });
            }			
		});

        this.setState({sections: sections});
        this.modal.handleShow();
    }

    clear(){
        this.setState({
            sections:[],
            serology:false,
            select_section:false
        });
    }

    onCheck(e, i){
        if(e.target.name === 'serology'){
            var sections = this.state.sections.map((section)=>{
                section.checked = false;

                return section;
            });


            this.setState({
                serology:e.target.checked,
                select_section:false,
                sections:sections
            });
        }else if(e.target.name === 'select_section'){
            this.setState({
                serology:false,
                select_section:e.target.checked
            });
        }else{
            var sections = this.state.sections;
            sections[i].check = e.target.checked;
            this.setState({sections});
        }
    }

    async onPrint(e){
        

		if(this.state.serology){
            var variables = {
                file_type:'sample_results',
                id: this.props.id,
                printing:'direct'
            }
			await this.props.onPrintLab(e, variables);			
            await this.modal.handleClose();
		}

		if(this.state.select_section){
            var ids = [];

            this.state.sections.map((s)=>{
				if(s.check){
					ids.push(s.lab_section_id);
				}
			});
            
            var variables = {
                file_type:'sample_results_confirm',
                id: this.props.id,
                printing:'sections',
                ids:ids
            };

			if(ids.length > 0){
				await this.props.onPrintLab(e, variables);
                await this.modal.handleClose();
			}else{
				swal('Error', 'Debe seleccionar por lo menos una sección', 'error');
			}
		}

        
    }

    render(){
        return(
            <Modal
                title='Formato de Impresión'
                actionBtn={true}
                label="Imprimir"
                clear={this.clear}
                action={this.onPrint}
                onRef={ref => this.modal = ref}
            >
                <div className='row'>
                    <div className='col-xs-12'>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Formato</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <input type='checkbox' name='serology' value={this.state.serology} onChange={(e)=>this.onCheck(e)} checked={this.state.serology} /> 
                                    </td>
                                    <td>Serología</td>
                                </tr>
                                <tr>
                                    <td>
                                        <input type='checkbox' name='select_section' value={this.state.select_section} onChange={(e)=>this.onCheck(e)} checked={this.state.select_section} /> 
                                    </td>
                                    <td>Elegir Secciones</td>
                                </tr>
                                {this.state.select_section &&
                                    <>
                                        <tr>
                                            <td></td>
                                            <td>Secciones</td>
                                        </tr>
                                        {this.state.sections.map((section, i)=>
                                            <tr key={i}>
                                                <td>
                                                    <input type='checkbox' value={section.checcked} onChange={(e)=>this.onCheck(e, i)} checked={section.checked} /> 
                                                </td>
                                                <td>{section.lab_section_name}</td>
                                            </tr>
                                        )}
                                    </>
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>   
            </Modal>
        )
    }

}

export default SelectFormatPrint;